import { inject, InjectionToken, provideAppInitializer } from '@angular/core';
import { BUILD_INFO_CONST } from './build-info';

export interface BuildInfo {
  time: string;
  commit: string;
  branch?: string;
  tag?: string;
}

export const BUILD_INFO = new InjectionToken<BuildInfo>('BUILD_INFO', {
  providedIn: 'root',
  factory: () => ({
    time: BUILD_INFO_CONST.time,
    commit: BUILD_INFO_CONST.commit,
  }),
});

export const provideAsBuildInfo = () =>
  provideAppInitializer(() => {
    const buildInfo = inject(BUILD_INFO);

    document.body.setAttribute('data-build-time', buildInfo.time);

    const showInfo = (e: KeyboardEvent) => {
      const shouldShow = e.metaKey && e.shiftKey && e.key.toLowerCase() === 'b';

      if (shouldShow) {
        e.preventDefault();
        const date = new Date(buildInfo.time);
        const formatter = new Intl.DateTimeFormat('de-DE', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        });

        alert(`
          Build Time: ${formatter.format(date)}\n
          Commit: ${buildInfo.commit}\n
          Branch: ${buildInfo.branch ?? 'N/A'}\n
          Tag: ${buildInfo.tag ?? 'N/A'}`);

        document.body.removeEventListener('keydown', showInfo);
      }
    };

    document.body.addEventListener('keydown', showInfo);
  });
